<template>

    <div>
        <div class="aside_item">
            <div class="aside_img"></div>
            <div class="aside_wrap">
                <div class="aside_des"></div>
                <div class="card-description"><span></span><span></span></div>
            </div>
        </div>
    </div>

</template>

<script>
    import FastAverageColor from 'fast-average-color';

    export default {
        name: "TeaserMiniLoadingEx",
        props:{
        },
        data() {
            return {
            };
        },
        mounted() {
        },
        methods:{
        },
         computed: {
        }
    }
</script>

<style scoped>

</style>